import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';
import CollectionSvg from '@/assets/Collection.svg';

const Collection = ({ size, variant, className }: IconProps) => (
  <img
    src={CollectionSvg}
    className={cn(iconVariant({ variant, size, className }))}
    aria-hidden="true"
    alt=""
  />
);

export default Collection;
